module.exports = __webpack_public_path__ + "img/post3.819d1190.png";